import moment from 'moment';

import coreAPI from 'apis/core';

function enrichPatientObject(patient) {
  patient.patient_name = `${patient.forename} ${patient.surname}`;

  if (patient.metadata?.last_order_date) {
    patient.metadata.days_since_last_order = moment().diff(
      moment.unix(patient.metadata.last_order_date).startOf('day'),
      'days'
    );
  }

  if (patient.dependents?.length) {
    patient.dependents.forEach((dependent) => {
      if (dependent.metadata?.last_order_date) {
        dependent.metadata.days_since_last_order = moment().diff(
          moment.unix(dependent.metadata.last_order_date).startOf('day'),
          'days'
        );
      }
    });
  }

  return patient;
}

export const getPatients = async ({ page = 0, limit = 10, order, orderBy, pharmacyId }) => {
  const response = await coreAPI.patient.getPharmacyPatients({
    pharmacyId,
    page,
    limit,
    order,
    orderBy,
  });
  const { patients, pagination } = response;

  return {
    nextPage: pagination.next,
    previousPage: pagination.previous,
    currentPageNumber: pagination.current_page,
    patientsTotal: pagination.total,
    patients: patients.map(enrichPatientObject),
  };
};

export const getPharmacyPatients = async ({
  page = 0,
  limit = 10,
  order,
  filter,
  pharmacyId,
  searchQuery,
  sortBy,
}) => {
  const response = await coreAPI.patient.getPharmacyPatientsV3({
    pharmacyId,
    page,
    limit,
    order,
    filter,
    searchQuery,
    sortBy,
  });
  const { patients, pagination } = response;

  return {
    nextPage: pagination.next,
    previousPage: pagination.previous,
    currentPageNumber: pagination.current_page,
    patientsTotal: pagination.total,
    patients,
  };
};

export const searchPatient = async ({ pharmacyId, patientName }) => {
  const response = await coreAPI.patient.searchPharmacyPatient({ pharmacyId, patientName });
  const { patients } = response;

  return {
    patients: patients.map(enrichPatientObject),
  };
};

export const getPatientMedicines = async (params) => {
  const response = await coreAPI.patient.getPatientMedicines(params);
  if (!response.data?.length) return [];

  const medicinesByPatientId = response.data.reduce((acc, { patient, ...medicine }) => {
    if (!acc[patient._id]) {
      acc[patient._id] = { ...patient, medicines: [] };
      if (!medicine.dependent_id) acc[patient._id].main = true;
    }

    acc[patient._id].medicines.push(medicine);
    return acc;
  }, {});

  const medicinesByPatient = Object.values(medicinesByPatientId).sort((patient1, patient2) => {
    if (patient1.main === true) return -1;
    if (patient2.main === true) return 1;
    return patient1.forename > patient2.forename ? 1 : -1;
  });

  return medicinesByPatient;
};

export const getPatientInfo = async ({ patientId }) => {
  const response = await coreAPI.patient.getPatientInfo({ patientId });

  return response.data;
};

export const getPatientOrders = async ({ patientId, page, limit }) => {
  const response = await coreAPI.patient.getPatientOrders({ patientId, page, limit });

  return {
    orders: response.data,
    pagination: response.pagination,
  };
};

export default {};
